<template>
    <div :class="['icon-wrapper', backgroundColor]" >
        <div class="svg-wrapper">
            <font-awesome-icon :icon="[iconType, iconName]"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserIconLarge",
    props: {
        iconType: {
            type: String,
            required: true,
        },
        iconName: {
            type: String,
            required: true,
        },
        backgroundColor: {
            type: String,
            required: true,
        }
    },
}
</script>

<style lang="scss" scoped>
.icon-wrapper{
    @apply flex rounded-full h-20 w-20 bg-opacity-20;

    &.primary-bg{
        @apply bg-primary;
    }

    &.secondary-bg{
        @apply bg-primary;
    }

    .svg-wrapper{
        @apply content-center justify-center my-auto mx-auto fill-current text-black;

        svg{
            @apply text-3xl font-bold text-primary;
        }
    }
}

</style>